import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../../api/api";
import { IWheelOfFortuneGameState, WheelOfFortuneMode } from ".";

export interface IWheeOfFortuneSpinResponse {
    sectorIndex: number;
    freeSpinsCount: number;
};

export const wheelOfFortuneSpin = createAsyncThunk<IWheeOfFortuneSpinResponse, WheelOfFortuneMode>(
    'game/wheel-of-fortune/spin',
    async (mode: WheelOfFortuneMode) => await api.games.wheelOfFortune.spin(mode)
);

const wheelOfFortuneSpinHandler = (builder: ActionReducerMapBuilder<IWheelOfFortuneGameState>) => {
    builder
        .addCase(wheelOfFortuneSpin.pending, (state: IWheelOfFortuneGameState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(wheelOfFortuneSpin.fulfilled, (state: IWheelOfFortuneGameState, action: PayloadAction<IWheeOfFortuneSpinResponse>) => {
            state.loading = false;

            if (!action.payload)
                return;

            if (action.payload.freeSpinsCount !== undefined)
                state.freeSpinsCount = action.payload.freeSpinsCount;
        })
        .addCase(wheelOfFortuneSpin.rejected, (state: IWheelOfFortuneGameState) => {
            state.loading = false;
            state.error = 'Unable to spin wheel of fortune';
        });
};

export default wheelOfFortuneSpinHandler;